// ============================
// File: src/features/discovery/api/discoveryClient.js
// ============================
//
// Discovery already reached the backend (BASE was "/api"), so this is a move onto
// the shared client rather than a rescue. The report/summary helpers that were
// commented out with "implement server-side" now exist and are wired up.

import { get, post, demandPath, AI_TIMEOUT_MS } from "../../../api/http";

/**
 * POST /demands/{id}/discovery/run
 * body: { triageMeta, bpmnXml, bpmnLite, constraints }
 * -> { discovery_path, confidence, narrative, risks }
 */
export async function runDiscoveryRecommendation(demandId, payload) {
  return post(demandPath(demandId, "/discovery/run"), payload, { timeout: AI_TIMEOUT_MS });
}

/** Saved discovery result, so reopening the planner shows the last recommendation. */
export async function getDiscoverySummary(demandId) {
  return get(demandPath(demandId, "/discovery/summary"));
}

/** Summary plus the stored artifacts for the discovery stage. */
export async function getDiscoveryReport(demandId) {
  return get(demandPath(demandId, "/discovery/report"));
}
